import { faPerson } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tag } from 'primereact/tag'
import { colorMapping, formatTime, genderMapping, getDirection } from '../../../utils/notification-utils'


interface CameraEvent {
  cameraId: string
  eventType: string
  timestamp: string
  imageBase64: string
  metadata: Record<string, string>
}

interface AhcrEventCardProps {
  event: CameraEvent
  index: number
  displayMode: 'detailed' | 'simple'
  onImageClick: (event: CameraEvent) => void
}

export const AhcrEventCard = ({
  event,
  index,
  displayMode,
  onImageClick,
}: AhcrEventCardProps) => {
  if (displayMode === 'simple') {
    return (
      <div
        key={`ahcr-simple-${index}`}
        className='notification-grid-item simple-item ahcr-simple'
        onClick={() => onImageClick(event)}
      >
        <div className='simple-notification-content'>
          <div className='simple-expand-icon'>
            <i className='pi pi-search-plus'></i>
          </div>
          <div className=''>
            <div className='person-info-section'>
              <div className='person-icon'>
                <i className='pi pi-user'></i>
                <span>Pessoa Detectada</span>
              </div>
              {event.metadata?.Gender && (
                <div className='gender-info'>
                  <span
                    className={`gender-badge ${event.metadata.Gender?.toLowerCase()}`}
                  >
                    {event.metadata.Gender?.toLowerCase() === 'male'
                      ? 'M'
                      : event.metadata.Gender?.toLowerCase() === 'female'
                        ? 'F'
                        : '?'}
                  </span>
                </div>
              )}
            </div>
            <div className='simple-metadata'>
              {formatTime(event.timestamp)}
              <div className='camera-name'>
                <i className='pi pi-video'></i>
                <span>{event.cameraId}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      key={`ahcr-${index}`}
      className='notification-grid-item ahcr-notification'
      onClick={() => onImageClick(event)}
    >
      <div className='notification-image-container'>
        {event.imageBase64 ? (
          <img
            src={event.imageBase64}
            alt={`Pessoa detectada`}
            className='notification-image'
          />
        ) : (
          <div className='camera-placeholder'>
            <i className='pi pi-user'></i>
          </div>
        )}

        <div className='notification-info'>
          <div className='info-header'>
            <div className='camera-info'>
              <i className='pi pi-video'></i>
              <span>{event.cameraId}</span>
            </div>
            <div className='expand-icon'>
              <i className='pi pi-search-plus'></i>
            </div>
          </div>

          <div className='info-content'>
            <div className='person-detection-section'>
              <div className='person-attributes'>
                {event.metadata?.Gender && (
                  <Tag
                    severity={
                      event.metadata.Gender === 'male'
                        ? 'info'
                        : event.metadata.Gender === 'female'
                          ? 'warning'
                          : null
                    }
                    value={
                      genderMapping[
                      event.metadata.Gender?.toLowerCase() as keyof typeof genderMapping
                      ] || 'Desconhecido'
                    }
                    icon='pi pi-user'
                  />
                )}
                {(event.metadata?.Hat === 'true' ||
                  event.metadata?.Hat === 'yes') && (
                    <Tag
                      severity='success'
                      value='Chapéu'
                    />
                  )}
              </div>
              {(event.metadata?.TrousersColor ||
                event.metadata?.JacketColor) && (
                  <div className='color-attributes'>
                    {event.metadata?.TrousersColor && (
                      <div className='color-tag'>
                        <span
                          className={`color-indicator events-color-${event.metadata.TrousersColor?.toLowerCase()}`}
                        ></span>
                        <span>
                          Calça:{' '}
                          {colorMapping[
                            event.metadata.TrousersColor?.toLowerCase() as keyof typeof colorMapping
                          ] || event.metadata.TrousersColor}
                        </span>
                      </div>
                    )}
                    {event.metadata?.JacketColor && (
                      <div className='color-tag'>
                        <span
                          className={`color-indicator events-color-${event.metadata.JacketColor?.toLowerCase()}`}
                        ></span>
                        <span>
                          Blusa:{' '}
                          {colorMapping[
                            event.metadata.JacketColor?.toLowerCase() as keyof typeof colorMapping
                          ] || event.metadata.JacketColor}
                        </span>
                      </div>
                    )}
                  </div>
                )}
            </div>

            <div className='metadata-section'>
              <div className='metadata-row'>
                {formatTime(event.timestamp)}
              </div>
              <div className='metadata-row'>
                <Tag
                  severity='info'
                  value={
                    <>
                      <FontAwesomeIcon
                        icon={faPerson}
                        size='sm'
                        className='mr-1'
                      />
                      Pessoa
                    </>
                  }
                />
                {event.metadata?.Direction &&
                  getDirection(event.metadata.Direction)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
